export const onFormatDate = (date?: Date): string => {
  return !date
    ? ''
    : new Date(date).getDate().toString().padStart(2, '0') +
        '/' +
        (new Date(date).getMonth() + 1).toString().padStart(2, '0') +
        '/' +
        new Date(date).getFullYear();
};

export const parseDateFromString = (value?: string): Date | null => {
  if (!value) return null;

  const parts = value.trim().split(/[\/\-]/);
  if (parts.length !== 3) return null;

  const [dayStr, monthStr, yearStr] = parts;
  const day = Number.parseInt(dayStr, 10);
  const month = Number.parseInt(monthStr, 10) - 1;
  const year = Number.parseInt(yearStr, 10);

  if (Number.isNaN(day) || Number.isNaN(month) || Number.isNaN(year)) return null;

  const candidate = new Date(year, month, day);
  // Validate to ensure parsed components match (avoid Date auto-correction)
  if (
    candidate.getFullYear() !== year ||
    candidate.getMonth() !== month ||
    candidate.getDate() !== day
  ) {
    return null;
  }

  return candidate;
};
